
import { BaseCardResult } from '@xt/client/types/record-card'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { EnumStudyCardType } from '@xt/client/enums/course/index'
import moment from 'moment'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop() data: BaseCardResult

  get watchHour() {
    return (this.data.numberData ? this.data.numberData / (60 * 60) : 0).toFixed(1)
  }

  get MapNoon() {
    return '清晨'
  }

  get MinutesAndSecond() {
    return this.data.timeData ? moment(this.data.timeData).format('HH:mm') : 0
  }

  get Day() {
    return this.data.timeData ? moment(this.data.timeData).format('DD') : 0
  }

  get Month() {
    return this.data.timeData ? moment(this.data.timeData).format('MM') : 0
  }

  get Year() {
    return this.data.timeData ? moment(this.data.timeData).format('YYYY') : 0
  }

  get EnumStudyCardType() {
    return EnumStudyCardType
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
